import IEvent from "@/models/dto/IEvent";

export const events: IEvent[] = [
    {
        "id": 0,
        "type": "deviceOverspeed",
        "eventTime": "2022-10-29T04:30:22Z",
        "deviceId": 1,
        "positionId": 0,
        "geofenceId": 0,
        "maintenanceId": 0,
        "attributes": { "speed": 9.8812131, "speedLimit": 5.4 },
        "latitude": -4545.1245,
        "longitude": 45456212
    },
    {
        "id": 1,
        "type": "alarm",
        "eventTime": "2019-08-24T14:15:22Z",
        "deviceId": 1,
        "positionId": 0,
        "geofenceId": 0,
        "maintenanceId": 0,
        "attributes": { "alarm": "powerRestored" },
        "latitude": -4545.1245,
        "longitude": 45456212
    },
    {
        "id": 2,
        "type": "alarm",
        "eventTime": "2021-08-24T14:15:22Z",
        "deviceId": 2,
        "positionId": 0,
        "geofenceId": 0,
        "maintenanceId": 0,
        "attributes": { "alarm": "powerCut" },
        "latitude": -4545.1245,
        "longitude": 45456212
    },
    {
        "id": 2,
        "type": "geofenceEnter",
        "eventTime": "2021-08-24T14:15:22Z",
        "deviceId": 2,
        "positionId": 0,
        "geofenceId": 1,
        "maintenanceId": 0,
        "attributes": { "alarm": "powerCut" },
        "latitude": -4545.1245,
        "longitude": 45456212
    },
    {
        "id": 2,
        "type": "geofenceExit",
        "eventTime": "2021-08-24T14:15:22Z",
        "deviceId": 2,
        "positionId": 0,
        "geofenceId": 3,
        "maintenanceId": 0,
        "attributes": { "alarm": "powerCut" },
        "latitude": -4545.1245,
        "longitude": 45456212
    },
    {
        "id": 1,
        "type": "alarm",
        "eventTime": "2019-08-24T14:15:22Z",
        "deviceId": 1,
        "positionId": 0,
        "geofenceId": 0,
        "maintenanceId": 0,
        "attributes": { "alarm": "sos" },
        "latitude": -4545.1245,
        "longitude": 45456212
    },
]